import { AnalyticEventName, track } from 'src/core/utils/analytics';

export function trackAccountingSoftwareSwitched(): void {
  track(AnalyticEventName.BOOKKEEP_SETTINGS_ACCOUNTING_SOFTWARE_SWITCHED);
}

export function trackAccountingSoftwareNotSwitched(): void {
  track(AnalyticEventName.BOOKKEEP_SETTINGS_ACCOUNTING_SOFTWARE_NOT_SWITCHED);
}
